import { IRootState } from '..';

export const SELECTOR_CSAT_AVAILABLE_EVENTS = (state: IRootState) => state.Csat.availableEventsCsat;
export const SELECTOR_CSAT_IS_LOADED = (state: IRootState) => state.Csat.isLoaded;
